import { render } from "./EditOfferDialog.vue?vue&type=template&id=61dae7b2"
import script from "./EditOfferDialog.vue?vue&type=script&lang=js"
export * from "./EditOfferDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__